import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"calc(100% - 120px)"} }
const _hoisted_2 = { class: "d-flex py-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("toolbox", null, null, -1)

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { blocklyDispatcher } from "../../blockly/blocklyDispatcher";
import { blocklyStore } from '../../blockly/blocklyStore';
import { createToolbox } from "../../blockly/toolbox_v2";
import { SessionUser } from "../../utils/SessionUser";
import { UserBlockContents } from "../../../server/dto/generated/UserBlockContents";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import Loading from "../../components/common/LoadingView.vue";
import { GlobalImport } from "../../utils/GlobalImport";
import { translation } from "../../lang/Translation";
import { projectContext } from "../../blockly/ProjectContext";
import { SessionMemory } from "../../utils/SessionMemory";
import HelpButton from "./ui/HelpButton.vue";
import AssetsButton from './ui/AssetsButton.vue';
import RecommendButton from './ui/RecommendButton.vue';
import ToolboxButton from './ui/ToolboxButton.vue';
import SaveButton from "./ui/SaveButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlocklySection',
  setup(__props) {

const route = useRoute();
const project_id = route.params.project_id as string;
const loading = ref(false);
const t = translation;
const Blockly = GlobalImport.getBlockly();

// プロジェクトIDを保持
blocklyStore.project_id = project_id;

const isHorizontalLayout = false;

const readonly = route.query.readonly ||false;


let zoomScale = 0.5;
if(SessionMemory.instance.existsKey("workspace_scale")){
  zoomScale = parseFloat(SessionMemory.instance.getSession("workspace_scale"))
}

const zoomOpt = {
  controls: true,
  wheel: true,
  startScale: zoomScale,
  maxScale: 4.0,
  minScale: 0.2,
  scaleSpeed: 1.2,
};

const contextmenu = () => {
  // console.log('contextmenu');
};

const onClickReverseProperty = async () => {
  const savedBlocks = projectContext.positionEditResult.value;

  blocklyStore.workspace.getAllBlocks().forEach((block) => {
    // const attr = block.getInput("ATTR");
    savedBlocks.forEach((savedBlock) => {
      if (savedBlock.block_id === block.id) {
        const px = block.getField("position-x");
        if (px) px.setValue(savedBlock.x);
        const py = block.getField("position-y");
        if (py) py.setValue(savedBlock.y);
        const pz = block.getField("position-z");
        if (pz) pz.setValue(savedBlock.z);
      }
    });
  });
  await MessageDialog.info(
    t.to("保存された位置の設定が完了しました", "reverse_position_success")
  );

  // リセット
  projectContext.positionEditResult.value = [];
  hasEditedPosition.value = false;
};

// 保存した位置の反映ボタンを表示する
const hasEditedPosition = ref(false);

/**
 * Blockly画面の生成は画面のDOMが作られてから
 */
onMounted(() => {
  hasEditedPosition.value = projectContext.positionEditResult.value.length > 0;

  const parentBlockly = Blockly;
  const init = async () => {
    // toolboxを生成
    const toolBoxActual = createToolbox();

    

    // ツールを出しっぱなしにする。ならfalse
    parentBlockly.Flyout.prototype.autoClose = true;
    window.addEventListener('resize', function () {
      if (toolBoxActual) {
        toolBoxActual.responsive();
      }
    });
    window.addEventListener('load', function () {
      if (toolBoxActual) {
        toolBoxActual.responsive();
      }
    });

    loading.value = true;

    // プロジェクトIDでデータを取得
    const project: UserBlockContents = await blocklyStore.initProject(
      project_id,
      SessionUser.instance.userId
    );

    // プロジェクトロード済みのイベントを発行
    blocklyDispatcher.triggerLoadProject(project);
    console.assert(
      project.block_xml !== null && typeof project.block_xml !== "undefined",
      "project.block_xmlがnull of undefined @blocklysicene"
    );

    // ツールボックス構築
    toolBoxActual.notify();

    // ワークスペースを構築
    const Blockly = GlobalImport.getBlockly();
    blocklyStore.workspace = Blockly.inject("blocklyDiv", {
      media: "/node_modules/scratch-blocks/media/",
      toolbox: toolBoxActual.toXmlDom(),
      grid: {
        spacing: 20,
        length: 3,
        colour: "#ccc",
        snap: true,
      },
      move: {
        scrollbars: true,
        drag: true,
        wheel: true,
      },
      css:true,
      sounds: true,
      horizontalLayout: isHorizontalLayout,
      contextMenu: true,
      zoom: zoomOpt,
      trashcan: true,
      collapse: false,
    });

    // マウント時のイベントを発火
    blocklyDispatcher.triggerMountedWorkspace(blocklyStore.workspace);

    // blocklyDispatcher.off(BloclyDispatcher.TRIGGER_UPDATE_TOOLBOX);
    blocklyDispatcher.addUpdateToolboxListener(() => {
      // console.log('update toolbox');
      blocklyStore.workspace.updateToolbox(toolBoxActual.toXmlDom());
    });

    // ワークスペースの変更を検知してツールボックスを更新
    blocklyDispatcher.addChangeWorkSpaceListener(() => {
      // console.log('toolbox update on change workspace ');
      blocklyStore.workspace.updateToolbox(toolBoxActual.toXmlDom());
    });

    // // ツールボックスを更新
    // blocklyStore.workspace.updateToolbox(toolBoxActual.toXmlDom());

    // ワークスペースが切り替わった時のイベントを発火
    blocklyDispatcher.triggerChangeWorkSpace(blocklyStore.workspace);

    // const blockContents = blocklyStore.workspaceToXML;

    // ブロックでのマスタの初期表示
    const dom = Blockly.Xml.textToDom(project.block_xml);
    Blockly.Xml.domToWorkspace(dom, blocklyStore.workspace);

    // Zoomぼたんをクリックした（ワークスペース全体でキャッチ）
    document.querySelector("#app").addEventListener("click",()=>{
      // ズーム倍率を覚えておく
      SessionMemory.instance.setSession("workspace_scale", blocklyStore.workspace.scale)
      blocklyStore.workspace.getToolbox()
    })

    // blocklyに変更があったときのイベントハンドラ
    blocklyStore.workspace.addChangeListener((event) => {


      // コードのループ制限
      GlobalImport.getAnyWindow().LoopTrap = 1000;
      Blockly.JavaScript.INFINITE_LOOP_TRAP =
        'if (--window.LoopTrap == 0) throw "Infinite loop.";\n';

      const xml = Blockly.Xml.workspaceToDom(blocklyStore.workspace);
      const xml_text = Blockly.Xml.domToText(xml);

      // コードが変化したことを発火するイベント
      blocklyDispatcher.triggerChangeWorkSpace(xml_text);

      // ワークスペースで発生したイベントを発火する
      blocklyDispatcher.triggerEventOnWorkspace(event);

      // ロード終わった後に、作られたブロックで反応
      if (event.type === Blockly.Events.BLOCK_CREATE) {
        blocklyDispatcher.triggerCreateBlock(event);
      }
    });
  };

  init()
    .then(() => {
      loading.value = false;
    })
    .catch((error) => {
      loading.value = false;
      MessageDialog.error(`blockly tag at domToWorkspace ;contents ${error}`);
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ToolboxButton),
      _createVNode(SaveButton),
      _createVNode(HelpButton),
      _createVNode(AssetsButton),
      _createVNode(RecommendButton)
    ]),
    _createElementVNode("div", {
      id: "blocklyDiv",
      class: "h-100 w-100",
      onContextmenu: contextmenu
    }, null, 32),
    _hoisted_3,
    (hasEditedPosition.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "position-absolute bottom-0 end-0 m-5 btn btn-primary",
          onClick: onClickReverseProperty
        }, _toDisplayString(_unref(t).to("保存されたブロック位置を反映する", "reverse_position")), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})